export default {
    LOGGED_OUT: 0,
    LOGGED_IN: 1,
    ALWAYS: 2,
    MANAGER: 3,
    HUMAN_RESOURCES: 4,
    ADMIN: 5
};